// styles
import "../styles/main.scss";

// js
import "./main.js";
